module.exports = __webpack_public_path__ + "img/aParty_111223_G.d162599f.jpg";